import { useActiveAgenticLogicView } from "@src/features/ai/pages/agentic-logic/surface/useActiveAgenticLogicView";
import { useSelector } from "@src/store";
import { getAtlasCreationPhase } from "@src/store/slices/global";

import {
  type AtlasChatLayout,
  resolveAtlasChatLayout,
} from "@src/features/ai/utils/atlasCreationPhase";

/**
 * The Atlas chat's layout for what is on screen now. Read by the three frames
 * that differ between the two layouts — the layout shell (hides the page), the
 * chat overlay (drops the rail width for the centred column), and the rail
 * header (Exit chat instead of the minus) — each outside the page tree, so the
 * surface comes from the registered descriptor rather than context.
 */
export const useAtlasChatLayout = (): AtlasChatLayout => {
  const { surface, view } = useActiveAgenticLogicView();
  const phase = useSelector(getAtlasCreationPhase);
  return resolveAtlasChatLayout({
    surfaceKind: surface?.kind ?? null,
    view,
    phase,
  });
};
